import { create } from "zustand";
import { InterfaceChaseItem } from "../types/chase-item-types";
import { DriverInterface } from "../types/driver-type";
import { ConfirmTone } from "../components/confirm-dialog";

export interface DriverResponseInterface extends DriverInterface {
    chaseItem: InterfaceChaseItem[]
}

/** Per-action copy so each confirm reads like the thing it is about. */
export interface IConfirmContent {
    title?: string
    description?: string
    detail?: string
    confirmLabel?: string
    tone?: ConfirmTone
    /**
     * What the confirm is about. Chases, chase items and providers each have
     * their own id sequence, so id alone can match more than one open row.
     */
    scope?: "chase" | "chase-item" | "chase-file" | "provider"
}

interface IdefaultValues extends IConfirmContent {
    id: number | string,
    onClick: () => void
}

const defaultValues: IdefaultValues = {
    id: "",
    onClick: () => { }
}

interface IuseDeleteModel {
    onOpenDeletePopup: (values: IdefaultValues) => void,
    onCloseDeletePopup: () => void
    initialValues: IdefaultValues
}

export const useDeleteModel = create<IuseDeleteModel>((set) => ({
    initialValues: defaultValues,
    onOpenDeletePopup: (values: IdefaultValues) => set({
        initialValues: { ...defaultValues, ...values }
    }),
    onCloseDeletePopup: () => set({
        initialValues: defaultValues
    }),
}))
